module.exports = __webpack_public_path__ + "static/img/btn_xiaoyouka_nor.b6ccca1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_xiaoyouka_nor.png
// module id = QbMI
// module chunks = 1